import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"

import Button from "shared/components/Button/Button.js"

import loaderIcon from "assets/svg/loader.svg"

import styles from "./styles.css"

const ButtonLoading = ({
  isLoading,
  children,
  className,
  disabled,
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={disabled || isLoading}
      className={classNames(styles.btn, className)}
    >
      {isLoading && <img src={loaderIcon} />}
      {children}
    </Button>
  )
}

ButtonLoading.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool
}

ButtonLoading.defaultProps = {
  isLoading: false,
  children: null,
  className: "",
  disabled: false
}

export default ButtonLoading



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/ButtonLoading/index.js